import { render, staticRenderFns } from "./WebformInquiryDetail.vue?vue&type=template&id=69ace9b8"
import script from "./WebformInquiryDetail.vue?vue&type=script&lang=js"
export * from "./WebformInquiryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports